<a routerLink="/{{routerConstants.default}}">
    <img *ngIf="logoColor === undefined || logoColor === null" img class="logo" src="./assets/images/logo.svg" alt="logo" />
    <!-- <img class="logo" *ngIf="logoColor === 'white'" src="./assets/images/footerlogo.png " alt="logo" /> -->
</a>
